import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import LoadingScreen from './LoadingScreen';
import { Alert, Container } from '@mui/material';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { isAdmin, isSuperAdmin, isGroupAdmin, loadingGroupCheck } = usePermissions();

  // Se si sta caricando, mostra loading
  if (loading || loadingGroupCheck) {
    return <LoadingScreen />;
  }

  // Se non c'è utente, reindirizza al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Controlla se siamo in modalità "vedi admin"
  const viewAdminMode = localStorage.getItem('view_admin_mode') === 'true';
  
  // Se si sta impersonando, verifica se l'utente impersonato è un admin
  const impersonatedUserId = localStorage.getItem('impersonated_user_id');
  const impersonatedUserIdBackup = localStorage.getItem('impersonated_user_id_backup');
  const hasActiveImpersonation = !!impersonatedUserId || !!impersonatedUserIdBackup;
  
  // Se si sta impersonando E l'utente impersonato NON è admin E non siamo in modalità "vedi admin", reindirizza
  if (hasActiveImpersonation && !viewAdminMode && !isAdmin) {
    return <Navigate to="/employee-dashboard" replace />;
  }

  const canAccess = isSuperAdmin || isAdmin;

  // Se stiamo ancora verificando se è admin di gruppo, mostra loading invece di bloccare
  if (loadingGroupCheck) {
    return <LoadingScreen />;
  }
  
  if (!canAccess) {
    return (
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Alert severity="error">
          Accesso negato. Questa sezione appartiene all'area amministrativa.
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;

